module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kp-list-group-item clearfix"
  }, [_c('label', {
    staticClass: "kp-row box-title box-title__button box-radio",
    on: {
      "click": function($event) {
        return _vm.boxUpdateConfig({
          item: 'advanced',
          key: 'exibition_frequency',
          value: _vm.value
        });
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio"
    },
    domProps: {
      "checked": _vm.boxConfig.advanced.exibition_frequency === _vm.value
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.label))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.boxConfig.advanced.exibition_frequency === _vm.value),
      expression: "boxConfig.advanced.exibition_frequency === value"
    }]
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-036f996b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/advancedconfig/exibitionfrequency/options/general/Main.vue
 ** module id = 746
 ** module chunks = 1
 **/